export const countries = [
    { name: 'United States', code: '+1', flag: 'US' },
  { name: 'United States (CST)', code: '+1', flag: 'US' },
  { name: 'United States (EST)', code: '+1', flag: 'US' },
  { name: 'United States (MST)', code: '+1', flag: 'US' },
  { name: 'United States (PST)', code: '+1', flag: 'US' },
  { name: 'Afghanistan', code: '+93', flag: 'AF' },
  { name: 'Albania', code: '+355', flag: 'AL' },
  { name: 'Algeria', code: '+213', flag: 'DZ' },
  { name: 'American Samoa', code: '+1-684', flag: 'AS' },
  { name: 'Australia (ACST)', code: '+61', flag: 'AU' },
  { name: 'Australia (AEST)', code: '+61', flag: 'AU' },
  { name: 'Australia (AWST)', code: '+61', flag: 'AU' },
  { name: 'Australia (LHST)', code: '+61', flag: 'AU' },
  { name: 'Bangladesh', code: '+880', flag: 'BD' },
  { name: 'Brazil (ACT)', code: '+55', flag: 'BR' },
  { name: 'Brazil (AMT)', code: '+55', flag: 'BR' },
  { name: 'Brazil (BRT)', code: '+55', flag: 'BR' },
  { name: 'Canada (AST)', code: '+1', flag: 'CA' },
  { name: 'Canada (CST)', code: '+1', flag: 'CA' },
  { name: 'Canada (EST)', code: '+1', flag: 'CA' },
  { name: 'Canada (MST)', code: '+1', flag: 'CA' },
  { name: 'Canada (NST)', code: '+1', flag: 'CA' },
  { name: 'Canada (PST)', code: '+1', flag: 'CA' },
  { name: 'Chad', code: '+235', flag: 'TD' },
  { name: 'Chile', code: '+56', flag: 'CL' },
  { name: 'China', code: '+86', flag: 'CN' },
  { name: 'Colombia', code: '+57', flag: 'CO' },
  { name: 'Comoros', code: '+269', flag: 'KM' },
  { name: 'Congo (Brazzaville)', code: '+242', flag: 'CG' },
  { name: 'Congo (Kinshasa)', code: '+243', flag: 'CD' },
  { name: 'Costa Rica', code: '+506', flag: 'CR' },
  { name: 'Croatia', code: '+385', flag: 'HR' },
  { name: 'Cuba', code: '+53', flag: 'CU' },
  { name: 'Cyprus', code: '+357', flag: 'CY' },
  { name: 'Czech Republic', code: '+420', flag: 'CZ' },
  { name: 'France', code: '+33', flag: 'FR' },
  { name: 'Germany', code: '+49', flag: 'DE' },
  { name: 'India', code: '+91', flag: 'IN' },
  { name: 'Indonesia', code: '+62', flag: 'ID' },
  { name: 'Iran', code: '+98', flag: 'IR' },
  { name: 'Iraq', code: '+964', flag: 'IQ' },
  { name: 'Italy', code: '+39', flag: 'IT' },
  { name: 'Japan', code: '+81', flag: 'JP' },
  { name: 'Kenya', code: '+254', flag: 'KE' },
  { name: 'Malaysia', code: '+60', flag: 'MY' },
  { name: 'Mexico (CST)', code: '+52', flag: 'MX' },
  { name: 'Mexico (MST)', code: '+52', flag: 'MX' },
  { name: 'Mexico (PST)', code: '+52', flag: 'MX' },
  { name: 'Netherlands', code: '+31', flag: 'NL' },
  { name: 'New Zealand', code: '+64', flag: 'NZ' },
  { name: 'Nigeria', code: '+234', flag: 'NG' },
  { name: 'Pakistan', code: '+92', flag: 'PK' },
  { name: 'Philippines', code: '+63', flag: 'PH' },
  { name: 'Qatar', code: '+974', flag: 'QA' },
  { name: 'Russia (KRAT)', code: '+7', flag: 'RU' },
  { name: 'Russia (MSK)', code: '+7', flag: 'RU' },
  { name: 'Russia (OMST)', code: '+7', flag: 'RU' },
  { name: 'Russia (VLAT)', code: '+7', flag: 'RU' },
  { name: 'Russia (YAKT)', code: '+7', flag: 'RU' },
  { name: 'Saudi Arabia', code: '+966', flag: 'SA' },
  { name: 'Singapore', code: '+65', flag: 'SG' },
  { name: 'South Africa', code: '+27', flag: 'ZA' },
  { name: 'South Korea', code: '+82', flag: 'KR' },
  { name: 'Spain', code: '+34', flag: 'ES' },
  { name: 'Sri Lanka', code: '+94', flag: 'LK' },
  { name: 'Sweden', code: '+46', flag: 'SE' },
  { name: 'Switzerland', code: '+41', flag: 'CH' },
  { name: 'Thailand', code: '+66', flag: 'TH' },
  { name: 'Turkey', code: '+90', flag: 'TR' },
  { name: 'Ukraine', code: '+380', flag: 'UA' },
  { name: 'United Arab Emirates', code: '+971', flag: 'AE' },
  { name: 'United Kingdom', code: '+44', flag: 'GB' },
  { name: 'Vietnam', code: '+84', flag: 'VN' },
  { name: 'Others' }
];

export const getDefaultCountry = (flag = 'US') =>
  countries.find((c) => c.flag === flag);